import React, { useEffect, useState } from 'react';
import s from "./CartCard.module.css";
import { DeleteOutline, Add, Remove } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { formatNumber } from '../../helpers';
import { capitalizeWords, correctEncoding } from '../../helpers';
import useMediaQuery from '../../hooks/useMediaQuery';
import nolibro from "../../assets/nolibro.png";

export default function CartCard({product, deleteItem, calculateTotal, modalControl, disableCant}) {

    const productName = capitalizeWords(correctEncoding(product.titulo, product.id_santeria ? true : false));
    const productImage = product.imagen_odoo ? `data:image/png;base64,${product.imagen_odoo}` : (product.id_santeria && product.imagen) ? `${process.env.REACT_APP_IMG_API}${product.imagen}` : nolibro;

    // Tarjetas del carrito

    const [unidades, setUnidades] = useState(product.cant);
    const Navigate = useNavigate();

    const isSmallScreen = useMediaQuery('(max-width: 415px)');

    useEffect(()=>{
        let productsCart = [];

        productsCart = localStorage.getItem('order');  // Lo traigo
        productsCart = JSON.parse(productsCart);       // Y lo convierto a JSON

        if (productsCart.filter((e) => e.id_libro === product.id_libro && e.id_santeria === product.id_santeria).length > 0){  // Si este producto ya existe en el carrito
            productsCart.forEach((p,i)=>{
                if (p.id_libro === product.id_libro && p.id_santeria === product.id_santeria){
                    p.cant = unidades;          // Le sumo los amounts de esta card
                }
            })
        } else {                                   //  Si no no existe en el carrito
            productsCart.push({...product, cant: unidades});  //  Lo pusheo
        }

        localStorage.setItem('order', JSON.stringify(productsCart))   // Y subo al localStorage

        calculateTotal();

    },[unidades]);

    useEffect(()=>{
        setUnidades(product.cant);
    },[product.cant])

    const handleUnidades = function(el) {
        const value = el.value;
    
        // Permitir input vacío temporalmente
        if (value === "") {
            setUnidades("");
            return;
        }
    
        const numberValue = parseInt(value, 10);
        
        // Si no es número, mantener último valor válido
        if (isNaN(numberValue)) return;
    
        // Aplicar límites y actualizar estado
        let clampedValue = Math.max(1, Math.min(numberValue, 99));
        
        if (product.id_libro) {
            clampedValue = Math.min(clampedValue, product.stockMin);
        }
        
        clampedValue = Math.max(1, clampedValue);
        setUnidades(clampedValue);
    };

    const handleEmptyInput = function(el){
        if(!el.value){
            setUnidades(1);
        }
    }

    const handleBtns = function(action){

        if(action === "REMOVE" && (unidades <= 1 || !unidades)) return;
        if(action === "ADD" && (unidades >= 99)) return;

        if(action === "ADD"){
            if (product.id_santeria) {
                setUnidades(Number(unidades) + 1);
            } 
            // Si no es Santería, respetar el stock mínimo
            else if (unidades < product.stockMin) {
                setUnidades(Number(unidades) + 1);
            }
        }
        if(action === "REMOVE"){
            setUnidades(Number(unidades) - 1);
        }
    }

    const handleDelete = function(product_id){
        deleteItem(product_id);
    }

    const handleRedirect = () => {
        const titleSlug = product.titulo.replace(/\s+/g, '_');
        if(product.id_libro) {
            Navigate(`/Detalle/Libro/${titleSlug}/${product.id_libro}`);
        } else {
            Navigate(`/Detalle/Objetos/${product.id_santeria}`);
        }
    }

    return (
        <div className={isSmallScreen ? s.containerMobile : s.container}>
            <img alt={"Portada de " + productName} onClick={()=>{ modalControl && modalControl(false); handleRedirect();}} src={productImage}/>
            <div className={isSmallScreen ? s.dataMobile : s.data}>
                <div className={s.titulosContainer}>
                    <div className={s.tituloWrapper}>
                        <p className={s.titulo} onClick={()=>{modalControl && modalControl(false); handleRedirect();}}>
                            {productName}
                        </p>
                    </div>
                    {
                        product.editorial &&
                        <p className={s.autor}>{product.editorial.replace(/Ã±|Ñ/g, 'ñ')}</p>
                    }
                </div>
                <div className={isSmallScreen ? s.accionesContainerMobile : s.accionesContainer}>
                    {
                        disableCant ?
                        <div className={s.unidadesContainer}>
                            <Remove sx={{ fontSize: 20, color: "#BFBFBF"}}/>
                            <input type='number'  min="1" max="99" value={unidades} disabled/>
                            <Add sx={{ fontSize: 20, color: "#BFBFBF"}}/>
                        </div> :
                        <div className={s.unidadesContainer}>
                            <Remove sx={{ fontSize: 20, color: "#1C1B1F", cursor: "pointer"}} onClick={()=>{handleBtns("REMOVE");}}/>
                            <input type='number'  min="1" max="99" value={unidades} onBlur={(e)=>{handleEmptyInput(e.target)}} onChange={(e)=>{handleUnidades(e.target);}}/>
                            <Add sx={{ fontSize: 20, color: "#1C1B1F", cursor: "pointer"}} onClick={()=>{handleBtns("ADD");}}/>
                        </div>
                    }

                    {
                        product.precio === product.preciodescuento && 
                        <p className={s.precio}>{formatNumber(product.precio)}</p>
                    }
                    {
                        product.precio !== product.preciodescuento && 
                        <div>
                            <p className={s.precioDescuento}>{formatNumber(product.precio)}</p>
                            <p className={s.precio}>{formatNumber(product.preciodescuento)}</p>
                        </div>
                    }
                    {
                        disableCant ?
                        <DeleteOutline sx={{ fontSize: 26, color: "#BFBFBF"}}/> :
                        <DeleteOutline sx={{ fontSize: 26, color: "#1C1B1F", cursor: "pointer"}} onClick={()=>{handleDelete(product.id_libro || product.id_santeria);}}/>
                    }
                    
                </div>
            </div>
        </div>
    )
}
